<template>
  <div class="d-flex">
    <v-divider class="ml-1" vertical />
    <v-data-table
      :items-per-page="99999"
      :headers="headers"
      :items="branch.payments_invoices"
      hide-default-footer
      class="grey lighten-4 flex-grow-1 rounded-0"
    >
      <template v-slot:[`item.appointment_code`]="{ item }">
        <a
          :href="`/admin-appointment/${item.appointment_id}`"
          target="_blank"
          color="primary"
          class="d-flex"
        >
          <span class="body-2">
            {{ `#${item.appointment_code}` }}
          </span>
        </a>
      </template>
      <template v-slot:[`item.transaction_id`]="{ item }">
        <v-chip class="body-2">
          <small>{{ item.payment_id }}</small>
          <CopyToClipboard :value="item.payment_id" />
        </v-chip>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span class="body-2">
          {{ formatDate(item.created_at) }}
        </span>
      </template>
      <template v-slot:[`item.movement_value`]="{ item }">
        <span class="body-2 error--text">
          {{ formatMoney(item.movement_value) }}
        </span>
      </template>
      <template v-slot:[`item.host_value`]="{ item }">
        <span class="body-2 success--text">
          {{ formatMoney(item.host_value) }}
        </span>
      </template>
      <template v-slot:[`item.hauseful_value`]="{ item }">
        <span class="body-2 success--text">
          {{ formatMoney(item.hauseful_value) }}
        </span>
      </template>
    </v-data-table>
    <v-divider vertical />
  </div>
</template>

<script>
import CopyToClipboard from '@/components/app/CopyToClipboard'
import { catalogDate, catalogMonetary } from '@/util/catalog'

export default {
  name: 'InvoiceTable',

  props: {
    branch: {
      type: Object,
      required: true,
    },
  },

  components: {
    CopyToClipboard,
  },

  methods: {
    formatDate(date) {
      return catalogDate(date)
    },

    formatMoney(amount) {
      return catalogMonetary(amount)
    },
  },

  data() {
    return {
      headers: [
        {
          text: this.$t('hausefulInvoices.headers.appointmentCode'),
          value: 'appointment_code',
          sortable: false,
          width: '150',
        },
        {
          text: this.$t('hausefulInvoices.headers.transactionId'),
          value: 'transaction_id',
          sortable: false,
          width: '280',
        },
        {
          text: this.$t('hausefulInvoices.headers.createdAt'),
          value: 'created_at',
          sortable: false,
          width: '150',
        },
        {
          text: this.$t('hausefulInvoices.headers.movementValue'),
          value: 'movement_value',
          sortable: false,
          align: 'right',
          width: '150',
        },
        {
          text: this.$t('hausefulInvoices.headers.hostValue'),
          value: 'host_value',
          sortable: false,
          align: 'right',
          width: '150',
        },
        {
          text: this.$t('hausefulInvoices.headers.hausefulValue'),
          value: 'hauseful_value',
          sortable: false,
          align: 'right',
          width: '150',
        },
        {
          text: this.$t('hausefulInvoices.headers.realtyQuantity'),
          value: 'realty_quantity',
          sortable: false,
          align: 'center',
          width: '120',
        },
      ],
    }
  }
}
</script>
